/**
 * Top Pick Card Wrapper
 *
 * Routes picks to the appropriate card component based on pick type.
 */

import React from 'react';
import PlayerPropCard from './PlayerPropCard';
import GamePickCard from './GamePickCard';

export default function TopPickCard({ pick, featured = false }) {
  if (!pick) return null;

  // Route to appropriate card type
  if (pick.pick_type === 'player_prop') {
    return <PlayerPropCard pick={pick} featured={featured} />;
  }

  // Game picks (spread, total, moneyline)
  if (['game_spread', 'game_total', 'game_ml'].includes(pick.pick_type)) {
    return <GamePickCard pick={pick} featured={featured} />;
  }

  // Fallback for unknown pick types
  return (
    <div className="glass-card p-4">
      <p className="text-text-secondary">Unknown pick type: {pick.pick_type}</p>
    </div>
  );
}
